import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Register from './views/Register.vue'
import RegisterSuccess from './views/RegisterSuccess.vue'
import TableOfContents from './views/TableOfContents';
import PointsSystem from './views/PointsSystem';
import Story from './views/Story'
import Schedule from './views/Schedule'
import Eligibility from './views/Eligibility'
import P404 from './views/P404'
import firebase from 'firebase'
import DriverPortal from './views/DriverPortal';
import AdminPortal from './views/AdminPortal';

Vue.use(Router)

export default new Router({
// let router = new Router({
    mode  : 'history',
    base  : process.env.BASE_URL,
    routes: [
        {
            path     : '/',
            name     : 'home',
            component: Home
        },
        {
            path     : '/login',
            name     : 'login',
            component: Login
        },
        {
            path     : '/register',
            name     : 'register',
            component: Register
        },
        {
            path     : '/toc',
            name     : 'toc',
            component: TableOfContents,
            meta: {
                requiresAdmin: true
            }
        },
        {
            path     : '/success',
            name     : 'success',
            component: RegisterSuccess
        },
        {
            path     : '/points-system',
            name     : 'pointsSystem',
            component: PointsSystem
        },
        {
            path     : '/schedule',
            name     : 'schedule',
            component: Schedule
        },
        {
            path     : '/eligibility',
            name     : 'eligibility',
            component: Eligibility
        },
        {
            path     : '/driver-portal',
            name     : 'driverPortal',
            component: DriverPortal
        },
        {
            path     : '/admin-portal',
            name     : 'adminPortal',
            component: AdminPortal
        },
        {
            path     : '/story',
            name     : 'story',
            component: Story
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            // component: () => import(/* webpackChunkName: "story" */ './views/Story.vue')
        },
        {
            path     : '*',
            name     : 'p404',
            component: P404
        }

    ]
})

// router.beforeEach((to, from, next) => {
//     // check for requiredAdminGuard
//     if (to.matched.some(record => record.meta.requiresAdmin)) {
//         if (!firebase.auth().currentUser) //not logged in
//             next({
//                 path: '/login',
//                 query: {
//                     redirect: to.fullPath
//                 }
//             })
//     } else if (firebase.auth().currentUser) //logged in
//         next()
// })
//
// export default router
